var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlineZustellung(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 77 63",
    style: {
      enableBackground: "new 0 0 77 63"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.7,6.2c0-3-2.5-5.5-5.5-5.5H8.2c-3,0-5.5,2.5-5.5,5.5v28h0.5V36v8.1c0,2.8,2.3,5,5,5h18.3l-1.2,9.5 c-0.1,0.9,0.2,1.8,0.8,2.5c0.6,0.7,1.5,1.1,2.4,1.1h17.7c0.9,0,1.8-0.4,2.4-1.1c0.6-0.7,0.9-1.6,0.8-2.5l-1.3-9.4h18.1 c2.8,0,5-2.3,5-5V36v-1.8h0.5V6.2z M6,6.2C6,5,7,3.9,8.2,3.9h57.9c1.3,0,2.3,1,2.3,2.3v27H6V6.2z M8.2,46.4c-1.3,0-2.3-1-2.3-2.3 v-7.6h62.5v7.6c0,1.3-1,2.3-2.3,2.3H8.2z M28.6,59l1.2-9.4h15.1l1.3,9.3L28.6,59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.2,36.9c-2.4,0-4.4,2-4.4,4.4c0,2.4,2,4.4,4.4,4.4s4.4-2,4.4-4.4C41.6,38.8,39.6,36.9,37.2,36.9z  M37.2,42.3c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1S37.8,42.3,37.2,42.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineZustellung);
export default __webpack_public_path__ + "static/media/OnlineZustellung.299b9d6e32723c019bbb4ebe968ecc8d.svg";
export { ForwardRef as ReactComponent };